import {useAccessPayConfiguration, useMutationWithErrorHandling, usePost} from '@app/sdk';

export function useAddAddisReport() {
  const post = usePost();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function addAddisReport(data: {
    reasonCode: string;
    accountNumber: string;
    customerName: string;
    sortCode: string;
    bankAccountNumber: string;
    serviceUserNumber: string;
  }) {
    const request = {
      reportType: 'auddisinput',
      advices: [
        {
          payerName: data.customerName,
          reference: data.accountNumber,
          payerSortCode: data.sortCode,
          payerAccountNumber: data.bankAccountNumber,
          reasonCode: data.reasonCode,
        },
      ],
      serviceUserNumber: data.serviceUserNumber
    };
    return await post(`${accessPayConfig?.baseUrl}/debug/reports/auddis`, request);
  }

  return useMutationWithErrorHandling({
    mutationFn: addAddisReport,
  });
}
